// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overview-header {
  background-color: #fff;
  padding: 1rem 0.75rem 0.25rem 0.75rem;
  margin-top: -1.5rem;
  margin-right: calc(-1.5rem * 0.5);
  margin-left: calc(-1.5rem * 0.5);
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.031);
}

.sticky-header {
  position: sticky;
  top: 4.3rem;
  z-index: 1000;
}`, "",{"version":3,"sources":["webpack://./../portfolio/src/pages/ClientJobView/ClientJobView.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,qCAAA;EACA,mBAAA;EACA,iCAAA;EACA,gCAAA;EACA,mBAAA;EACA,4CAAA;AACF;;AAEA;EAEE,gBAAA;EACA,WAAA;EACA,aAAA;AACF","sourcesContent":[".overview-header {\n  background-color: #fff;\n  padding: 1rem 0.75rem 0.25rem 0.75rem;\n  margin-top: -1.5rem;\n  margin-right: calc(-1.5rem * 0.5);\n  margin-left: calc(-1.5rem * 0.5);\n  margin-bottom: 1rem;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.031);\n}\n\n.sticky-header {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 4.3rem;\n  z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
